<template>
  <!-- <DxPopup @hidden="onHidden" :visible="showSurveyPop" :title="menuTitle" :height=window.h :width=window.w container=".v-application"> -->
  <DxPopup @hidden="onHidden" :visible="showSurveyPop" :title="menuTitle" :height="850" :width="1280" container=".v-application">
    <DxScrollView
        width="100%"
        height="100%"
        direction="both"
      >
      <div>
        <surveyComponent/>
      </div>

  </DxScrollView>

  </DxPopup>
</template>

<script>
import baseview from '@/components/base/baseview'
import { DxPopup } from 'devextreme-vue/popup'
import { DxScrollView } from 'devextreme-vue/scroll-view'
import surveyComponent from '../../../../components/survey/SurveyComponent.vue'

export default {
  name: 'surveyPop',
  mixins: [baseview],
  components: {
    DxPopup,
    DxScrollView,
    surveyComponent
},
  props: {
    showSurveyPop: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
     return {
       menuTitle: 'HIP CUSTOMER SURVEY',
       openChk: false,
      //  window: {
      //       w: 0,
      //       h: 0,
      //       hDx: 0
      // }
     }
  },
  watch: {
    'showSurveyPop': {
      handler(value, oldValue) {
        if(value) {
          this.init()
          // window.addEventListener('resize', this.handleResize)
          // window.removeEventListener('resize', this.handleResize)
          // this.handleResize()
        }
      },
      immediate: true
    }
  },
  // mounted(){
  //   window.addEventListener('resize', this.handleResize);
  //   this.handleResize();
  // },
  // destroyed() {
  //   window.removeEventListener('resize', this.handleResize);
  // },
  methods: {
    // handleResize() {
    //   this.window.w   = window.innerWidth - 100;
    //   this.window.h   = window.innerHeight - 100;
    //   this.window.hDx = window.innerHeight - 380;
    // },
    init() {
    },
    onHidden(e) {
      this.$emit('update:showSurveyPop', false)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>